import html2canvas from 'html2canvas';
import jsPDF from 'jspdf';

export const generatePDF = async (elementId: string, fileName: string) => {
    const element = document.getElementById(elementId);
    if (!element) return;

    try {
        // Enforce full page height to push footer to bottom
        const originalStyleHeight = element.style.height;
        const originalStyleMinHeight = element.style.minHeight;

        // Calculate aspect ratio height
        const pageWidth = element.offsetWidth;
        const pageHeight = pageWidth * 1.4142; // A4 Aspect Ratio
        const totalHeight = element.scrollHeight;
        const pages = Math.ceil(totalHeight / pageHeight);
        const targetHeight = pages * pageHeight;

        element.style.minHeight = `${targetHeight}px`;

        const canvas = await html2canvas(element, {
            scale: 2, // Higher resolution
            backgroundColor: '#000000', // Ensure black background
            useCORS: true, // Handle cross-origin images if any
            logging: false,
        });

        // Restore original styles
        element.style.height = originalStyleHeight;
        element.style.minHeight = originalStyleMinHeight;

        const imgData = canvas.toDataURL('image/png');
        const pdf = new jsPDF('p', 'mm', 'a4');
        const imgProps = pdf.getImageProperties(imgData);
        const pdfWidth = pdf.internal.pageSize.getWidth();
        const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;
        const pageHeightPdf = pdf.internal.pageSize.getHeight();

        let heightLeft = pdfHeight;
        let position = 0;

        // First page
        pdf.setFillColor(0, 0, 0);
        pdf.rect(0, 0, pdfWidth, pageHeightPdf, 'F');
        pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
        heightLeft -= pageHeightPdf;

        while (heightLeft > 0) {
            position = heightLeft - pdfHeight;
            pdf.addPage();
            pdf.setFillColor(0, 0, 0);
            pdf.rect(0, 0, pdfWidth, pageHeightPdf, 'F');
            pdf.addImage(imgData, 'PNG', 0, position, pdfWidth, pdfHeight);
            heightLeft -= pageHeightPdf;
        }

        pdf.save(`${fileName}.pdf`);
    } catch (error) {
        console.error('Error generating PDF:', error);
        alert('Failed to generate PDF. Please try again.');
    }
};
